import React, { Ref } from 'react';
import { Field } from 'formik';

import { useField } from 'components/Common/Formik/hooks/useField';
import {
  Props as TurnstileProps,
  Ref as TurnstileRef,
  TurnstileWidget,
} from './TurnstileWidget';

type Props = {
  name?: string;
  fieldProps?: Omit<typeof Field, 'name'>;
  turnstileProps?: TurnstileProps;
  turnstileRef?: Ref<TurnstileRef>;
};

export default function TurnstileFormikField({
  name = 'turnstileToken',
  fieldProps,
  turnstileProps,
  turnstileRef,
}: Props): JSX.Element {
  const [, , { setValue }] = useField(name);
  const { options, onSuccess, onExpire, onError, ...customTurnstileProps } =
    turnstileProps || {};

  return (
    <>
      <TurnstileWidget
        {...customTurnstileProps}
        onBeforeInteractive={() => {
          setValue(''); // Reset the input value before interaction, this is used for the reset action.
        }}
        onSuccess={token => {
          setValue(token);
          onSuccess?.(token);
        }}
        onExpire={token => {
          setValue('');
          onExpire?.(token);
        }}
        onError={error => {
          setValue('');
          onError?.(error);
        }}
        ref={turnstileRef}
        options={{ responseField: false, ...options }}
      />

      <Field name={name} type="hidden" {...fieldProps} />
    </>
  );
}

export type { Props, TurnstileRef };
